export { ResponsivePicture } from "./ResponsivePicture";
export type { PictureVariant } from "./ResponsivePicture";
